import { BilagLibraryItem as _BilagLibraryItem } from '@team-milva/lab-models/bilagLibraryItem'
import type { IBilagLibraryItem as _IBilagLibraryItem } from '@team-milva/lab-models/bilagLibraryItem'

export class BilagLibraryItem extends _BilagLibraryItem {
  constructor(params: Partial<_IBilagLibraryItem> = {}) {
    super(params)
  }
}
